import { render, staticRenderFns } from "./ai-email-templates-dropdown.vue?vue&type=template&id=d1fc4fa0&scoped=true"
import script from "./ai-email-templates-dropdown.vue?vue&type=script&lang=ts"
export * from "./ai-email-templates-dropdown.vue?vue&type=script&lang=ts"
import style0 from "./ai-email-templates-dropdown.vue?vue&type=style&index=0&id=d1fc4fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fc4fa0",
  null
  
)

export default component.exports